<template>
  <div>
    <v-expansion-panels class="mb-5" accordion>
      <v-expansion-panel
        v-for="paymentsPerRealEstate in invoiceHalf"
        :key="paymentsPerRealEstate.name"
      >
        <v-expansion-panel-header class="pa-3">
          <v-col cols="6" sm="6">
            <h5 class="grey--text text-uppercase">
              {{ `${$t('hostInvoices.realEstate')}` }}
            </h5>
            <span class="d-block subtitle-1 font-weight-bold text-truncate">
              {{ paymentsPerRealEstate.name }}
            </span>
          </v-col>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-expansion-panels class="mb-5" accordion>
            <v-expansion-panel
              v-for="paymentsPerBranch in paymentsPerRealEstate.branches"
              :key="paymentsPerBranch.cnpj"
            >
              <v-expansion-panel-header class="pa-3">
                <v-col cols="6" sm="6">
                  <span class="d-block subtitle-2 text-truncate">
                    {{ paymentsPerBranch.cnpj ? paymentsPerBranch.name : paymentsPerRealEstate.name }}
                  </span>
                </v-col>
                <v-col cols="5" sm="5 " class="text-right">
                  <h6 class="text-uppercase grey--text">
                    {{ `${$t('hostInvoices.total')}` }}
                  </h6>
                  <span class="subtitle-2 success--text">
                    {{ formatMoney(paymentsPerBranch.total) }}
                  </span>
                </v-col>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-data-table
                  :search="search"
                  :headers="headers"
                  :items="paymentsPerBranch.payments"
                  :no-results-text="$t('table.noResults')"
                  :footer-props="{
                    'items-per-page-text': '',
                    'items-per-page-options': [],
                  }"
                  mobile-breakpoint="20"
                >
                  <template v-slot:top>
                    <div class="invoices__action-wrap">
                      <div class="invoices__search">
                        <v-text-field
                          v-model="search"
                          :label="$t('table.searchText')"
                          class="invoices__search-input mw-200 pt-0 mt-0"
                          append-icon="mdi-magnify"
                          hide-details
                          dense
                        />
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.code`]="{ item }">
                    {{ `#${item.code}` }}
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    <span>{{ formatDate(item.date) }}</span>
                  </template>
                  <template v-slot:[`item.value`]="{ item }">
                    <span>
                      {{ formatMoney(item.value) }}
                    </span>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { invoiceHeader } from '@/views/listHeaders/paymentListHeaders'
export default {
    name: 'HostInvoicePanel',
    data() {
        return {
            search: '',
            formatDate: catalogDate,
            formatMoney: catalogMonetary,
            headers: invoiceHeader
        }
    },
    props: {
        invoiceHalf: {
          required: true
        },
    },
    methods:{
    },
}
</script>
